import { render, staticRenderFns } from "./featuredNewsList.vue?vue&type=template&id=443dd4ef&scoped=true&"
import script from "./featuredNewsList.vue?vue&type=script&lang=js&"
export * from "./featuredNewsList.vue?vue&type=script&lang=js&"
import style0 from "./featuredNewsList.vue?vue&type=style&index=0&id=443dd4ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443dd4ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/featurednews/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443dd4ef')) {
      api.createRecord('443dd4ef', component.options)
    } else {
      api.reload('443dd4ef', component.options)
    }
    module.hot.accept("./featuredNewsList.vue?vue&type=template&id=443dd4ef&scoped=true&", function () {
      api.rerender('443dd4ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/featuredNewsList.vue"
export default component.exports